import { render, staticRenderFns } from "./ActualizeRulesDialog.vue?vue&type=template&id=23b5d548&scoped=true"
import script from "./ActualizeRulesDialog.vue?vue&type=script&lang=js"
export * from "./ActualizeRulesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b5d548",
  null
  
)

export default component.exports